(() => {
  const drawer = document.querySelector('[data-cart-drawer]')
  const overlay = document.querySelector('[data-cart-overlay]')
  const countNodes = document.querySelectorAll('[data-cart-count], [data-drawer-count]')
  const subtotalNode = document.querySelector('[data-cart-subtotal]')
  const cartContent = document.querySelector('[data-cart-content]')
  const moneyFormat = document.documentElement.dataset.moneyFormat || '${{amount}}'

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2)
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)).replace('.', ','))
  }

  const openDrawer = () => {
    if (!drawer) return
    drawer.open = true
    if (overlay) overlay.hidden = false
    document.body.classList.add('cart-is-open')
    document.querySelector('[data-cart-close]')?.focus()
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'))
  }

  const closeDrawer = () => {
    if (!drawer) return
    drawer.open = false
    if (overlay) overlay.hidden = true
    document.body.classList.remove('cart-is-open')
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'))
  }

  const make = (tag, className, text) => {
    const element = document.createElement(tag)
    if (className) element.className = className
    if (text !== undefined) element.textContent = text
    return element
  }

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(cart.item_count) })
    document.querySelectorAll('[data-drawer-count]').forEach((node) => { node.textContent = `(${cart.item_count})` })
    if (!cartContent) return
    cartContent.replaceChildren()
    if (!cart.items.length) {
      cartContent.append(make('p', 'cart-empty-message', 'Your bag is currently empty.'))
      const link = make('a', 'button button-dark', 'Continue shopping')
      link.href = '/collections/all'
      cartContent.append(link)
      return
    }

    cart.items.forEach((item) => {
      const row = make('div', 'cart-drawer-item')
      row.dataset.cartLine = item.key
      if (item.image) {
        const image = document.createElement('img')
        image.src = item.image
        image.alt = item.product_title
        image.loading = 'lazy'
        row.append(image)
      }
      const info = make('div')
      const title = make('a', '', item.product_title)
      title.href = item.url
      info.append(title)
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(make('p', '', item.variant_title))
      info.append(make('p', '', formatMoney(item.final_line_price)))
      const label = make('label', 'sr-only', `Quantity for ${item.product_title}`)
      const quantity = document.createElement('input')
      quantity.type = 'number'
      quantity.min = '0'
      quantity.value = String(item.quantity)
      quantity.dataset.cartQuantity = ''
      quantity.dataset.lineKey = item.key
      label.htmlFor = `CartQuantity-${item.key.replace(/[^a-zA-Z0-9]/g, '')}`
      quantity.id = label.htmlFor
      info.append(label, quantity)
      const remove = make('button', 'text-button', 'Remove')
      remove.type = 'button'
      remove.dataset.cartRemove = ''
      remove.dataset.lineKey = item.key
      info.append(remove)
      row.append(info)
      cartContent.append(row)
    })

    const total = make('div', 'cart-drawer-total')
    total.append(make('span', '', 'Subtotal'), make('strong', '', formatMoney(cart.total_price)))
    const checkout = make('a', 'button button-dark cart-checkout', 'Review bag and checkout')
    checkout.href = '/cart'
    cartContent.append(total, checkout)
  }

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
    if (!response.ok) throw new Error('Unable to refresh cart')
    renderCart(await response.json())
  }

  const changeCart = async (key, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(quantity) }),
    })
    if (!response.ok) throw new Error('Unable to update cart')
    renderCart(await response.json())
  }

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-cart-open]')
    if (opener) {
      event.preventDefault()
      openDrawer()
      return
    }
    if (event.target.closest('[data-cart-close]') || event.target === overlay) closeDrawer()
    const remove = event.target.closest('[data-cart-remove]')
    if (remove) {
      try { await changeCart(remove.dataset.lineKey, 0) } catch { window.location.assign('/cart') }
    }
    const thumbnail = event.target.closest('[data-gallery-thumb]')
    if (thumbnail) {
      const product = thumbnail.closest('[data-product-root]')
      product?.querySelectorAll('[data-gallery-image]').forEach((image) => image.classList.toggle('is-hidden', image.dataset.mediaId !== thumbnail.dataset.mediaId))
      product?.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.classList.toggle('is-active', button === thumbnail))
    }
  })

  document.addEventListener('change', async (event) => {
    const quantity = event.target.closest('[data-cart-quantity]')
    if (quantity) {
      try { await changeCart(quantity.dataset.lineKey, quantity.value) } catch { window.location.assign('/cart') }
    }
    const sort = event.target.closest('[data-sort-select]')
    if (sort) {
      const form = sort.closest('form')
      form?.querySelectorAll('input[type="hidden"]').forEach((input) => input.remove())
      form?.submit()
    }
    const option = event.target.closest('[data-option-index]')
    if (option) updateVariant(option.closest('[data-product-root]'))
  })

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-add], [data-product-form]')
    if (!form) return
    event.preventDefault()
    const button = form.querySelector('[type="submit"]')
    const error = form.querySelector('[data-product-error]')
    if (button) button.disabled = true
    if (error) { error.hidden = true; error.textContent = '' }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      const result = await response.json()
      if (!response.ok) throw new Error(result.description || 'This item could not be added.')
      await refreshCart()
      if (document.body.dataset.enableCartDrawer === 'true') openDrawer()
      else window.location.assign('/cart')
    } catch (errorValue) {
      if (error) { error.textContent = errorValue.message || 'This item could not be added.'; error.hidden = false }
      else window.alert(errorValue.message || 'This item could not be added.')
    } finally {
      if (button) button.disabled = false
    }
  })

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer?.open) closeDrawer() })

  const updateVariant = (root) => {
    if (!root) return
    const variantsNode = root.dataset.productVariants
    if (!variantsNode) return
    let variants
    try { variants = JSON.parse(variantsNode) } catch { return }
    const values = [...root.querySelectorAll('[data-option-index]')].map((select) => select.value)
    const variant = variants.find((item) => item.options.every((value, index) => value === values[index]))
    const idInput = root.querySelector('[data-variant-id]')
    const button = root.querySelector('[data-add-to-cart]')
    const label = root.querySelector('[data-add-label]')
    if (!variant) {
      if (button) button.disabled = true
      if (label) label.textContent = 'Unavailable'
      return
    }
    if (idInput) idInput.value = variant.id
    if (button) button.disabled = !variant.available
    if (label) label.textContent = variant.available ? 'Add to bag' : 'Sold out'
    const price = root.querySelector('[data-product-price] .price-current')
    if (price) price.textContent = formatMoney(variant.price)
    const sku = root.querySelector('[data-product-sku]')
    if (sku) sku.textContent = variant.sku || ''
    const url = new URL(window.location.href)
    url.searchParams.set('variant', variant.id)
    window.history.replaceState({}, '', url)
    if (variant.featured_media?.id) {
      const target = root.querySelector(`[data-gallery-image][data-media-id="${variant.featured_media.id}"]`)
      if (target) {
        root.querySelectorAll('[data-gallery-image]').forEach((image) => image.classList.toggle('is-hidden', image !== target))
        root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(variant.featured_media.id)))
      }
    }
  }

  if (subtotalNode) refreshCart().catch(() => {})
})()
